import React, { useState, useEffect } from "react";

import { NavbarBroker } from "../NavbarBroker";
import { NavbarMobileBroker } from "../NavbarMobileBroker";
import { ChatsList } from "./ChatsList";
import { MessageDetail } from "./MessageDetail";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import AditionalsChatroom from "./AditionalsChatroom";
import ModalPlantilla from "./ModalPlantilla";
import ModalPlantillaEdit from "./ModalPlantillaEdit";
import { motion, AnimatePresence } from "framer-motion";
import { io as ioClient } from "socket.io-client";
import { useAppSelector } from "../../../hooks/hooks";
import { NavbarHotel } from "../../dashboardHotel/NavbarHotel";
import { NavbarMobileHotel } from "../../dashboardHotel/NavbarMobileHotel";

export interface ChatSelect {
    chatId: string;
    name: string;
    unread: number;
}

export interface plantillas {
    id: number;
    mensaje: string;
    titulo: string;
    orden: number;
    imagenes: imagen[];
    archivos: archivo;
    tipo: string;
}

interface imagen {
    id: string;
    imagen: string;
    orden: number;
    caption: string;
}

interface archivo {
    id: string;
    archivo: string;
    orden: number;
    caption: string;
}

export interface Chat {
    id: string;
    name: string;
    lastMessage: string;
    messageType: string;
    fromMe: boolean;
    isRead: boolean;
    sentAt: string;
    profilePicture: any;
    unread: number;
}

interface MediaFile {
    file: File;
    base64: string;
    name: string;
    caption: string;
}

export const ChatRoom = ({ hotel }: { hotel: boolean }) => {
    const [chatSelect, setChatSelect] = useState<ChatSelect>({
        chatId: "",
        name: "",
        unread: 0,
    });

    const [modalPlantilla, setModalPlantilla] = useState(false);
    const [modalPlantillaEdit, setModalPlantillaEdit] = useState(false);
    const [idPlantilla, setIdPlantilla] = useState(0);
    const socketServer = process.env.REACT_APP_PROXY_ARCHIVOS || "";
    const [plantillas, setPlantillas] = useState<plantillas[]>([]);

    const [mensajes, setMensajes] = useState<any[]>([]);

    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [chats30, setChats30] = useState<Chat[]>([]);
    const [vista, setVista] = useState<string>("chats");
    const [selectedFiles, setSelectedFiles] = useState<MediaFile[]>([]);
    const [fileSeleccionadoIndex, setFileSeleccionadoIndex] = useState<
        number | null
    >(null);
    const [nuevoMensaje, setNuevoMensaje] = useState("");
    const corredor = useAppSelector((state) => state.corredor);
    const casa = useAppSelector((state) => state.landing_house.house);

    console.log("chatSelect", chatSelect);
    console.log("corredor", corredor);

    useEffect(() => {
        const socketWhatsApp = ioClient(`${socketServer}/whatsapp`, {
            auth: {
                token: JSON.stringify({
                    token: hotel
                        ? casa.token_whatsapp
                        : corredor.token_whatsapp,
                }),
            },
        });

        socketWhatsApp.on("connect", () => {
            console.log("Conectado al namespace /whatsapp");
        });

        socketWhatsApp.on("whatsapp-message", ({ chats, mensaje }) => {
            console.log("chatSelect.chatId", chatSelect.chatId);
            console.log("📲 WhatsApp nuevo:", mensaje);
            if (mensaje.id === chatSelect.chatId) {
                setChatSelect((prev) => ({
                    ...prev,
                    unread: 0,
                }));
                fetchAxiosToken({
                    url: `/pedidos/chat-visto-whatsapp`,
                    method: "post",
                    body: {
                        chatId: mensaje.id,
                        unread: 1,
                        token_whatsapp: hotel
                            ? casa.token_whatsapp
                            : corredor.token_whatsapp,
                    },
                });
                setMensajes((prev) => [...prev, mensaje]);
                setChats30(chats.chats);
            } else {
                setChats30(chats.chats);
            }
        });

        return () => {
            socketWhatsApp.disconnect();
        };
    }, [corredor.token_whatsapp, chatSelect, casa.token_whatsapp]);

    const getChats30 = async (pageToLoad: number) => {
        if (loading) return;
        setLoading(true);
        try {
            const data = await fetchAxiosToken({
                url: `/pedidos/obtener-30-chats-whatsapp/${pageToLoad}`,
                body: {
                    token_whatsapp: hotel
                        ? casa.token_whatsapp
                        : corredor.token_whatsapp,
                },
                method: "post",
            });
            const { chats, page: newPage, totalPages: newTotal } = data.chats;

            setChats30((prev) =>
                pageToLoad === 0 ? chats : [...prev, ...chats]
            );
            setPage(newPage);
            setTotalPages(newTotal);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getChats30(0);
    }, [casa.token_whatsapp]);

    const loadMore = () => {
        if (page < totalPages - 1) {
            getChats30(page + 1);
        }
    };
    const handleEditPlantilla = (id: number) => {
        setIdPlantilla(id);
        setModalPlantillaEdit(true);
    };

    const render = () => {
        return (
            <>
                <div className="w-11/12 mx-auto max-w-7xl hidden md:grid grid-cols-[20%,60%,20%] mt-0 md:mt-8">
                    {
                        <ChatsList
                            setChatSelect={setChatSelect}
                            chats30={chats30}
                            setChats30={setChats30}
                            loadMore={loadMore}
                            hasMore={page < totalPages - 1}
                            loading={loading}
                            setVista={setVista}
                        />
                    }
                    {
                        <MessageDetail
                            chatSelect={chatSelect}
                            setChats30={setChats30}
                            setVista={setVista}
                            selectedFiles={selectedFiles}
                            setSelectedFiles={setSelectedFiles}
                            nuevoMensaje={nuevoMensaje}
                            setNuevoMensaje={setNuevoMensaje}
                            mensajes={mensajes}
                            setMensajes={setMensajes}
                            fileSeleccionadoIndex={fileSeleccionadoIndex}
                            setFileSeleccionadoIndex={setFileSeleccionadoIndex}
                            hotel={hotel}
                        />
                    }

                    {
                        <AditionalsChatroom
                            setModalPlantilla={setModalPlantilla}
                            setPlantillas={setPlantillas}
                            plantillas={plantillas}
                            handleEditPlantilla={handleEditPlantilla}
                            chatSelect={chatSelect}
                            isOpenModal={false}
                            setVista={setVista}
                            selectedFiles={selectedFiles}
                            setSelectedFiles={setSelectedFiles}
                            nuevoMensaje={nuevoMensaje}
                            setNuevoMensaje={setNuevoMensaje}
                            setFileSeleccionadoIndex={setFileSeleccionadoIndex}
                        />
                    }
                </div>

                <div className="w-11/12 mx-auto md:hidden flex mt-2 relative overflow-hidden h-[calc(100vh-100px)]">
                    <AnimatePresence mode="wait">
                        {vista === "chats" && (
                            <motion.div
                                key="chats"
                                initial={{ x: -100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                exit={{ x: -100, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                className="absolute w-full">
                                <ChatsList
                                    setChatSelect={setChatSelect}
                                    chats30={chats30}
                                    setChats30={setChats30}
                                    loadMore={loadMore}
                                    hasMore={page < totalPages - 1}
                                    loading={loading}
                                    setVista={setVista}
                                />
                            </motion.div>
                        )}

                        {vista === "chatDetail" && (
                            <motion.div
                                key="chatDetail"
                                initial={{ x: 100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                exit={{ x: 100, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                className="absolute w-full">
                                <MessageDetail
                                    hotel={hotel}
                                    chatSelect={chatSelect}
                                    setChats30={setChats30}
                                    setVista={setVista}
                                    selectedFiles={selectedFiles}
                                    setSelectedFiles={setSelectedFiles}
                                    nuevoMensaje={nuevoMensaje}
                                    setNuevoMensaje={setNuevoMensaje}
                                    mensajes={mensajes}
                                    setMensajes={setMensajes}
                                    fileSeleccionadoIndex={
                                        fileSeleccionadoIndex
                                    }
                                    setFileSeleccionadoIndex={
                                        setFileSeleccionadoIndex
                                    }
                                />
                            </motion.div>
                        )}

                        {vista === "config" && (
                            <motion.div
                                key="config"
                                initial={{ x: 100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                exit={{ x: 100, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                className="absolute w-full">
                                <AditionalsChatroom
                                    setModalPlantilla={setModalPlantilla}
                                    setPlantillas={setPlantillas}
                                    plantillas={plantillas}
                                    handleEditPlantilla={handleEditPlantilla}
                                    chatSelect={chatSelect}
                                    isOpenModal={true}
                                    setVista={setVista}
                                    selectedFiles={selectedFiles}
                                    setSelectedFiles={setSelectedFiles}
                                    nuevoMensaje={nuevoMensaje}
                                    setNuevoMensaje={setNuevoMensaje}
                                    setFileSeleccionadoIndex={
                                        setFileSeleccionadoIndex
                                    }
                                />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </>
        );
    };

    return (
        <div className="">
            <ModalPlantilla
                modalPlantilla={modalPlantilla}
                setModalPlantilla={setModalPlantilla}
                setPlantillas={setPlantillas}
            />

            <ModalPlantillaEdit
                modalPlantilla={modalPlantillaEdit}
                setModalPlantilla={setModalPlantillaEdit}
                setPlantillas={setPlantillas}
                id_plantilla={idPlantilla}
            />
            {hotel ? (
                <>
                    <NavbarHotel titulo="Chat Room">
                        {render()}
                        <NavbarMobileHotel />
                    </NavbarHotel>
                </>
            ) : (
                <>
                    <NavbarBroker titulo="Chat Room">
                        {render()}
                        <NavbarMobileBroker />
                    </NavbarBroker>
                </>
            )}
        </div>
    );
};
